import { DocumentSubType } from '../../../graphql/graphql';

/**
 * Maps API document subType to jsTranslation keys (component.CSSZSickLeaveCertificateSubmissionSubType.*).
 */
const SUB_TYPE_TO_TX: Record<string, string> = {
	BASE: 'component.CSSZSickLeaveCertificateSubmissionSubType.base',
	[DocumentSubType.ChangeAddress]:
		'component.CSSZSickLeaveCertificateSubmissionSubType.changeAddress',
	[DocumentSubType.ChooseOutings]:
		'component.CSSZSickLeaveCertificateSubmissionSubType.chooseOutings',
	[DocumentSubType.Hol]:
		'component.CSSZSickLeaveCertificateSubmissionSubType.hol',
	[DocumentSubType.MedicalRequestForm]:
		'component.CSSZSickLeaveCertificateSubmissionSubType.medicalRequestForm',
	[DocumentSubType.MedicalReviewForm]:
		'component.CSSZSickLeaveCertificateSubmissionSubType.medicalReviewForm',
	[DocumentSubType.Ptdpn]:
		'component.CSSZSickLeaveCertificateSubmissionSubType.ptdpn',
	[DocumentSubType.Rdpn1]:
		'component.CSSZSickLeaveCertificateSubmissionSubType.rdpn1',
	[DocumentSubType.Rdpn3]:
		'component.CSSZSickLeaveCertificateSubmissionSubType.rdpn3',
	[DocumentSubType.ReturnAdmission]:
		'component.CSSZSickLeaveCertificateSubmissionSubType.returnAdmission',
	[DocumentSubType.Update]:
		'component.CSSZSickLeaveCertificateSubmissionSubType.update',
};

export function getSickLeaveSubmissionSubTypeTx(
	subType: string | null | undefined,
): string | null {
	if (subType == null || subType === '') {
		return null;
	}
	return SUB_TYPE_TO_TX[subType] ?? null;
}
